import { Brand } from '../models/brand';
import { Upc } from '../models/upc';

// TODO: Remove DemoScenario, brandsForScenario, and MOCK_BRANDS when wired to a real API
export type DemoScenario = 'populated' | 'fewer' | 'single' | 'empty' | 'loading' | 'error';

export function brandsForScenario(scenario: DemoScenario): Brand[] {
    switch (scenario) {
        case 'fewer': return MOCK_BRANDS.slice(0, 3);
        case 'single': return MOCK_BRANDS.slice(0, 1);
        case 'empty': return [];
        default: return MOCK_BRANDS; // populated / loading / error
    }
}

export const EXISTING_BRANDS: Brand[] = [
    new Brand({
        brandId: 1111,
        brandName: 'Mill Creek Botanicals',
        upcCount: 12,
        upcs: [
            new Upc({ upc: '123456789101', productName: '2in1 Shave Gel Eucalyptus',  itemSize: '8 oz',    category: 'Personal Care', catalogBrand: 'Mill Creek Botanicals' }),
            new Upc({ upc: '123456789102', productName: 'Biotin Shampoo',              itemSize: '16 oz',   category: 'Hair Care',     catalogBrand: 'Mill Creek Botanicals' }),
            new Upc({ upc: '123456789103', productName: 'Aloe Vera Gel',               itemSize: '8 oz',    category: 'Skin Care',     catalogBrand: 'MCB' }),
            new Upc({ upc: '123456789104', productName: 'Keratin Repair Mask',         itemSize: '10 oz',   category: 'Hair Care',     catalogBrand: 'Mill Creek Botanicals' }),
            new Upc({ upc: '123456789105', productName: 'Jojoba Oil Conditioner',      itemSize: '14 oz',   category: 'Hair Care',     catalogBrand: 'Mill Creek Botanicals' }),
            new Upc({ upc: '123456789106', productName: 'Lavender Shampoo',            itemSize: '16 oz',   category: 'Hair Care',     catalogBrand: 'Mill Creek Botanicals' }),
            new Upc({ upc: '123456789107', productName: 'Tea Tree Body Wash',          itemSize: '12 oz',   category: 'Body Care',     catalogBrand: 'Mill Creek Botanicals' }),
            new Upc({ upc: '123456789108', productName: 'Eucalyptus Conditioner',      itemSize: '14 oz',   category: 'Hair Care',     catalogBrand: 'Mill Creek Botanicals' }),
            new Upc({ upc: '123456789109', productName: 'Peppermint Shampoo',          itemSize: '8 oz',    category: 'Hair Care',     catalogBrand: 'MCB' }),
            new Upc({ upc: '123456789110', productName: 'Argan Oil Serum',             itemSize: '4 oz',    category: 'Hair Care',     catalogBrand: 'Mill Creek Botanicals' }),
            new Upc({ upc: '123456789111', productName: 'Chamomile Facial Wash',       itemSize: '6 oz',    category: 'Skin Care',     catalogBrand: 'Mill Creek Botanicals' }),
            new Upc({ upc: '123456789112', productName: 'Rosemary Mint Shampoo',       itemSize: '16 oz',   category: 'Hair Care',     catalogBrand: 'Mill Creek Botanicals' }),
        ],
    }),
    new Brand({
        brandId: 2222,
        brandName: "Burt's Bees",
        upcCount: 4,
        upcs: [
            new Upc({ upc: '998877665501', productName: 'Lip Balm Original',           itemSize: '0.15 oz', category: 'Lip Care',      catalogBrand: "Burt's Bees" }),
            new Upc({ upc: '998877665502', productName: 'Hand Salve',                  itemSize: '3 oz',    category: 'Skin Care',     catalogBrand: "Burt's Bees" }),
            new Upc({ upc: '998877665503', productName: 'Beeswax Lip Balm Peppermint', itemSize: '0.15 oz', category: 'Lip Care',      catalogBrand: 'BB' }),
            new Upc({ upc: '998877665504', productName: 'Res-Q Ointment',              itemSize: '0.6 oz',  category: 'Skin Care',     catalogBrand: "Burt's Bees" }),
        ],
    }),
    new Brand({
        brandId: 3333,
        brandName: "Tom's of Maine",
        upcCount: 2,
        upcs: [
            new Upc({ upc: '776655443301', productName: 'Natural Toothpaste Peppermint', itemSize: '4 oz',    category: 'Oral Care',     catalogBrand: "Tom's of Maine" }),
            new Upc({ upc: '776655443302', productName: 'Deodorant Lavender',             itemSize: '2.25 oz', category: 'Personal Care', catalogBrand: "Tom's" }),
        ],
    }),
];

export const MOCK_BRANDS: Brand[] = [
    new Brand({
        brandId: 9999,
        brandName: 'Green Valley Organics Co',
        upcCount: 3,
        createdDate: new Date('2025-03-22'),
        upcs: [
            new Upc({ upc: '445566778899', productName: 'Oat Milk Shampoo',       itemSize: '12 oz', category: 'Hair Care',  catalogBrand: 'Green Valley Organics Co' }),
            new Upc({ upc: '445566778900', productName: 'Oat Milk Conditioner',   itemSize: '12 oz', category: 'Hair Care',  catalogBrand: 'GVO' }),
            new Upc({ upc: '445566778901', productName: 'Oat Milk Body Lotion',   itemSize: '16 oz', category: 'Body Care',  catalogBrand: 'Green Valley Organics Co' }),
        ],
    }),
    new Brand({
        brandId: 7777,
        brandName: 'Burts Bees',
        upcCount: 2,
        createdDate: new Date('2025-03-21'),
        upcs: [
            new Upc({ upc: '998877001122', productName: 'Lip Balm Mango',         itemSize: '0.15 oz', category: 'Lip Care',  catalogBrand: 'Burts Bees' }),
            new Upc({ upc: '998877001123', productName: 'Coconut Foot Cream',     itemSize: '4 oz',    category: 'Skin Care', catalogBrand: 'Burts Bees' }),
        ],
    }),
    new Brand({
        brandId: 5555,
        brandName: 'MCB Natural',
        upcCount: 1,
        createdDate: new Date('2025-03-20'),
        upcs: [
            new Upc({ upc: '112233445566', productName: 'Jojoba Shampoo',         itemSize: '8 oz',  category: 'Hair Care',  catalogBrand: 'MCB Natural' }),
        ],
    }),
    new Brand({
        brandId: 4444,
        brandName: 'Mill Creek Botanica',
        upcCount: 4,
        createdDate: new Date('2025-03-17'),
        upcs: [
            new Upc({ upc: '987654321001', productName: 'Keratin Conditioner',    itemSize: '14 oz', category: 'Hair Care',  catalogBrand: 'Mill Creek Botanica' }),
            new Upc({ upc: '987654321002', productName: 'Tea Tree Shampoo',       itemSize: '8 oz',  category: 'Hair Care',  catalogBrand: 'MCB' }),
            new Upc({ upc: '987654321003', productName: 'Lavender Body Wash',     itemSize: '12 oz', category: 'Body Care',  catalogBrand: 'Mill Creek Botanica' }),
            new Upc({ upc: '123456789102', productName: 'Biotin Shampoo',         itemSize: '16 oz', category: 'Hair Care',  catalogBrand: 'MCB' }),
        ],
    }),
];
